import React, { useState } from 'react';
import { MessageInput, MessageInputProps, useChannelStateContext, useMessageInputContext } from 'stream-chat-react';

import { MESSAGE_COPY } from 'shared/config/copy';

const EditMessageInput: React.FC<MessageInputProps> = (props) => {
  const [keyboardOpen, setKeyboardOpen] = useState(false);
  const { channel: activeChannel } = useChannelStateContext();
  const { clearEditingState } = useMessageInputContext();

  return (
    <MessageInput
      {...props}
      minRows={1}
      maxRows={10}
      additionalTextareaProps={{
        onFocus: () => setKeyboardOpen(true),
        onBlur: () => setKeyboardOpen(false),
        placeholder: activeChannel?.data?.frozen
          ? MESSAGE_COPY.FROZEN_MESSAGE_INPUT_PLACEHOLDER
          : MESSAGE_COPY.DEFAULT_MESSAGE_INPUT_PLACEHOLDER,
      }}
      hideSendButton={activeChannel?.data?.frozen}
      clearEditingState={clearEditingState}
    />
  );
};

export default EditMessageInput;
